import {Injectable, Inject} from '@angular/core';
import {Observable} from 'rxjs';
import {SoundcloudChannel, SoundCloudApiSearchResult} from "../../modele/social-media/soundcloudModels";
import {HttpHeaders, HttpClient, HttpResponse} from '@angular/common/http';
import {NGXLogger} from "ngx-logger";

export const GIPHY_API = 'https://api.giphy.com/v1/gifs/search?';
export const GIPHY_API_KEY = '0RM5RSXLrpqk5Tc8wSFW0geL5gfnN9FV';

@Injectable({
  providedIn: 'root'
})
export class GiphyService {
    log_prefix = this.constructor.name + ":";
    GIPHY_API_KEY = '0RM5RSXLrpqk5Tc8wSFW0geL5gfnN9FV';

  constructor(
      private http: HttpClient,
      @Inject(GIPHY_API) private apiUrl: string,
      @Inject(GIPHY_API_KEY) private apiKey: string,
      private logger: NGXLogger

  ) { }

   search(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";
       const params = `&q=@${query}&limit=5&offset=0&rating=g&lang=de`;
       const queryUrl = `${this.apiUrl}api_key=${this.apiKey}${params}`;
       return new Observable<any[]>((observer) => {
           this.http.get(queryUrl).subscribe(resp => {
               let data = resp['data'];
               observer.next(data);
           });
       });
   }
   searchForPost(query: string): Observable <any[] > {
       let lp = this.log_prefix + "search:";
       const params = `&q=${query}&limit=20&offset=0&rating=g&lang=de`;
       const queryUrl = `${this.apiUrl}api_key=${this.apiKey}${params}`;
       return new Observable<any[]>((observer) => {
           this.http.get(queryUrl).subscribe(resp => {
               let data = resp['data'];
               observer.next(data);
           });
       });
   }

}
